'use client';

import React, { useState, useEffect } from 'react';
import Message from 'components/commercetools-ui/atoms/message';
import { TasticProps } from '../types';
import { desktop } from '../../../helpers/utils/screensizes';

interface NotificationProps {
  mobile: boolean;
  tablet: boolean;
  desktop: boolean;
  content: string;
  periodStart: string | null;
  periodEnd: string | null;
  type: string;
  widthDesktop: 'full' | 'half';
  maxWidthInPxDesktop: number;
  widthMobile: 'full' | 'half';
  maxWidthInPxMobile: number;
  alignDesktop: 'center' | 'left' | 'right';
  alignMobile: 'center' | 'left' | 'right';
}

const NotificationTastic = ({ data }: TasticProps<NotificationProps>) => {
  const periodStart = data.periodStart ? new Date(data.periodStart) : new Date();
  const periodEnd = data.periodEnd ? new Date(data.periodEnd) : new Date('9999-12-31');
  const now = new Date();

  const isInPeriod = now >= periodStart && now <= periodEnd;

  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    if (window) setWindowWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isDesktop = windowWidth >= desktop;
  const width = isDesktop
    ? data.widthDesktop === 'full'
      ? '100%'
      : '50%'
    : data.widthMobile === 'full'
    ? '100%'
    : '50%';
  const maxWidth = isDesktop ? data.maxWidthInPxDesktop : data.maxWidthInPxMobile;
  const textAlign = isDesktop ? data.alignDesktop : data.alignMobile;

  const wrapperStyle = {
    padding: '16px',
    display: 'flex',
    justifyContent: textAlign === 'center' ? 'center' : textAlign === 'left' ? 'flex-start' : 'flex-end',
    width: '100%',
  };

  const messageStyle = {
    width: width,
    maxWidth: maxWidth > 0 ? `${maxWidth}px` : '',
  };

  return isInPeriod && windowWidth !== 0 ? (
    <div style={wrapperStyle}>
      <div style={messageStyle}>
        <Message severity={data.type} message={data.content} />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default NotificationTastic;
